import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FormControl, FormControlLabel, MenuItem, Radio, RadioGroup, Select, Switch, TextField } from "@material-ui/core";
import Swal from "sweetalert2";
import moment from "moment";

import { PRODUCT_TYPES } from "./../../global/userConstants";

const role = localStorage.getItem("role");

const AddNewMemberPopup = (props) => {
  const [state, setState] = useState({
    newEmail: "",
    newFirstName: "",
    newLastName: "",
    newLicenseNumber: "",
    newMobile: "",
    newEndOfSubscription: "",
    newStatus: "active",
    newJobType: "regular",
    newSoftwareServiceType: "",
    newAbilities: [],
    newDisableTaxAuthorityDocumentConfirmation: false,
    attachRole: "",
    adminSetManualPassword: ""
  });

  const cardJobTitle = props.cardJobTitle;

  return (
    <div>
      <Dialog open={props.isOpen} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle className="yellow-color">הוספת משתמש חדש - {props.newMemberType === "btaxMembers" ? "BTax" : "BQuick"}</DialogTitle>
        <DialogContent>
          <TextField id="newEmail" value={state.newEmail} label='דוא"ל' className="field-strech" onChange={handleChange} />
          <TextField id="newFirstName" value={state.newFirstName} label="שם פרטי" className="ml-20" onChange={handleChange} />
          <TextField id="newLastName" value={state.newLastName} label="שם משפחה" className="" onChange={handleChange} />
          <TextField id="newMobile" value={state.newMobile} label="מספר נייד" className="" onChange={handleChange} />
          <TextField id="newLicenseNumber" value={state.newLicenseNumber} label="מספר רשיון" className="" onChange={handleChange} />

          <div className="mt-10">
            סיום תוקף המנוי
            <TextField id="newEndOfSubscription" value={state.newEndOfSubscription} type="date" onChange={handleChange} />
          </div>

          <div className="mt-10">
            סטטוס
            <FormControl>
              <Select
                value={state.newStatus || ""}
                onChange={(e) => handleChange({ target: { id: "newStatus", value: e.target.value } })}
                displayEmpty
              >
                <MenuItem value="active">פעיל</MenuItem>
                <MenuItem value="suspended">מושהה</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="mt-10">
            תפקיד
            <FormControl>
              <Select
                value={state.newJobType || ""}
                onChange={(e) => handleChange({ target: { id: "newJobType", value: e.target.value } })}
                displayEmpty
              >
                <MenuItem value="regular">רגיל</MenuItem>
                <MenuItem value="manager">מנהל</MenuItem>
              </Select>
            </FormControl>
          </div>
          {props.newMemberType === "btaxMembers" ? (
            <>
              <div className="mt-10">
                שימוש בתוכנה
                <FormControl>
                  <Select
                    value={state.newSoftwareServiceType || ""}
                    onChange={(e) => handleChange({ target: { id: "newSoftwareServiceType", value: e.target.value } })}
                    displayEmpty
                  >
                    <MenuItem value="btax">BTax</MenuItem>
                    <MenuItem value="btaxYam">BTax Yam</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {state.newSoftwareServiceType === "btax" ? (
                <div className="mt-10">
                  הרחבות
                  <TextField
                    value={state.newAbilities || []}
                    type="select"
                    select={true}
                    SelectProps={{ multiple: true }}
                    variant="outlined"
                    size="small"
                    onChange={(e) => handleChange({ target: { id: "newAbilities", value: e.target.value } })}
                  >
                    <MenuItem value="combination">קומבינציה</MenuItem>
                    <MenuItem value="prisaExt">פריסה מורחב</MenuItem>
                  </TextField>
                </div>
              ) : null}

              <div className="mt-10">
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={state.newDisableTaxAuthorityDocumentConfirmation}
                      onChange={(e) =>
                        handleChange({
                          target: { id: "newDisableTaxAuthorityDocumentConfirmation", value: e.target.checked }
                        })
                      }
                    />
                  }
                  label="דלג על אישור לפני הפקת מסמכי רשות המסים"
                />
              </div>
            </>
          ) : null}

          {role === "admin" && (
            <div>
              <hr />
              <RadioGroup
                value={state.attachRole}
                className="flex-direction-row"
                onChange={(e) => {
                  setState({ ...state, attachRole: e.target.value });
                }}
              >
                <FormControlLabel value="" control={<Radio />} label="regular" />
                <FormControlLabel value="salesManager" control={<Radio />} label="salesManager" />
                <FormControlLabel value="salesman" control={<Radio />} label="salesman" />
              </RadioGroup>

              <TextField id="adminSetManualPassword" value={state.adminSetManualPassword} label="Manual password" onChange={handleChange} />
            </div>
          )}

          <div className="mt-30">
            <Button variant="contained" onClick={newMember} color="primary">
              שמור משתמש חדש
            </Button>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              const newState = { ...state };
              newState.newSoftwareServiceType = "";
              newState.newAbilities = [];
              newState.newDisableTaxAuthorityDocumentConfirmation = false;
              setState(newState);
              props.closePopup();
            }}
            color="primary"
          >
            בטל וסגור
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

  function newMember() {
    if (
      !state.newEmail ||
      !state.newFirstName ||
      !state.newLastName ||
      !state.newEndOfSubscription ||
      !state.newStatus ||
      !state.newJobType ||
      !state.newLicenseNumber ||
      !state.newMobile
    ) {
      return Swal.fire("", "חובה למלא את כל הנתונים");
    }
    let actualMemberType = PRODUCT_TYPES.bquick;
    if (props.newMemberType === "btaxMembers") {
      if (!state.newSoftwareServiceType) {
        return Swal.fire("", "חובה למלא את כל הנתונים");
      }
      actualMemberType = PRODUCT_TYPES.btax;
    }

    props.tryAddNewMemberAndPushList(state, actualMemberType);
  }

  function handleChange(e) {
    const newState = { ...state };
    let finalValue = e.target.value;

    if (e.target.id === "newEndOfSubscription") {
      const date = new Date(e.target.value);
      
      if (date.getMonth() === 1) { // February
        const day = date.getDate();
        if (day === 15 || day === 16) {
          if (cardJobTitle === "shamai") {
            Swal.fire({
              title: `יש לשים לב שנבחר תאריך מיוחד שבו יש רק שמאי לשכה שאינם משלמים על המערכת. אם לא מדובר בשמאי בבקשה לשנות את השדה של "עיסוק" וגם לשנות לתאריך אחר את סיום המנוי לדוגמה ה-17.`,
              icon: "info",
              confirmButtonColor: "#e9d700"
            });
          } else {
            date.setDate(17);
            finalValue = moment(date).format("YYYY-MM-DD");
            e.target.value = finalValue;
          }
        }
      }
    }

    newState[e.target.id] = finalValue;
    setState(newState);
  }
};

export default AddNewMemberPopup;
